import { Host, h } from "@stencil/core";
/**
 * @slot - The first level items (entities) of the data model
 */
export class NextDataModeling {
    render() {
        return (h(Host, { role: "list" }, h("slot", null)));
    }
    static get is() { return "ch-next-data-modeling"; }
    static get originalStyleUrls() {
        return {
            "$": ["next-data-modeling.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["next-data-modeling.css"]
        };
    }
}
//# sourceMappingURL=next-data-modeling.js.map
